type PendingLoginAnalytics = {
  custom_page_name: string
}

let pendingLoginAnalytics: PendingLoginAnalytics | null = null

export function setPendingLoginAnalytics(pending: PendingLoginAnalytics): void {
  pendingLoginAnalytics = pending
}

export function consumePendingLoginAnalytics(): PendingLoginAnalytics | null {
  const pending = pendingLoginAnalytics
  pendingLoginAnalytics = null
  return pending
}

export function getPendingLoginAnalytics(): PendingLoginAnalytics | null {
  return pendingLoginAnalytics
}

export function clearPendingLoginAnalytics(): void {
  pendingLoginAnalytics = null
}

export const _resetPendingLoginAnalyticsForTests = clearPendingLoginAnalytics
